import React from 'react';
import cx from 'clsx';
import styles from './GameDetailsTop.module.scss';
import { GameTileProps, GameClickProps } from '../../modular-grid/types';
import { GameMode } from 'src/types/gameTypes';
import GameDetailsMultipleImages from './GameDetailsTopImages/GameDetailsMultipleImages';
import GameDetailsSingleImage from './GameDetailsTopImages/GameDetailsSingleImage';
import GameDetailsTopInfo from './GameDetailsTopInfo/GameDetailsTopInfo';

export interface GameDetailsTopMessages {
  features: string;
  tableInfo: string;
  playButton: string;
  practiceButton?: string;
}
export interface GameDetailsTopPropTypes {
  game: GameTileProps;
  onGameButtonClick: ({
    game,
    gamePosition,
    sectionTitle,
    gameMode,
  }: {
    game: GameClickProps;
    gamePosition: number;
    sectionTitle: string;
    gameMode?: GameMode;
  }) => void;
  staticTexts: GameDetailsTopMessages;
  pageTitle?: string;
}

const GameDetailsTop: React.FC<GameDetailsTopPropTypes> = ({
  game,
  onGameButtonClick,
  staticTexts,
  pageTitle,
}) => {
  return (
    <div
      data-testid="game-details-header"
      className={cx(
        game.infoPageImages ? styles.headerWrapper : styles.headerWrapperSmall
      )}
    >
      <div
        className={cx(
          styles.headerContent,
          !game.infoPageImages && styles.headerContentSimple
        )}
      >
        {game.infoPageImages ? (
          <GameDetailsMultipleImages
            images={game.infoPageImages}
            title={game.title}
          />
        ) : (
          <GameDetailsSingleImage image={game.image} title={game.title} />
        )}
        <GameDetailsTopInfo
          game={game}
          staticTexts={staticTexts}
          pageTitle={pageTitle}
          onGameButtonClick={onGameButtonClick}
        />
      </div>
    </div>
  );
};

export default GameDetailsTop;
